<template>
  <div class="container container--fluid">
    <v-row>
      <v-col cols="12">
        <PageTitle icon="mdi-star" text="مدرک های من" />
      </v-col>
      <v-col cols="12">
        <CertsTable />
        <BaseModal show-close width="350px">
          <template v-slot:body>
            <PayForm />
          </template>
          <template v-slot:footer>
            <v-card-text class="warning text-center font-weight-bold">
              6037998112962609 <br/>
              به نام علی باغبان قراملکی
            </v-card-text>
          </template>
        </BaseModal>
      </v-col>
    </v-row>
  </div>
</template>

<script>
import PageTitle from "@/packages/dashboard/components/PageTitle";
import { mapGetters } from "vuex";
import CertsTable from "@/packages/dashboard/components/CertsTable";
import BaseModal from "@/components/app/modal/BaseModal";
import PayForm from "@/packages/dashboard/components/PayForm";
export default {
  name: "Index",
  components: { PayForm, BaseModal, CertsTable, PageTitle },
  computed: {
    ...mapGetters({
      is_loading: "loading/is_loading",
    }),
  },
};
</script>

<style scoped></style>
